import React, { useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import StatusLabel from "../components/status-label/StatusLabel";
import BarLoader from "react-spinners/BarLoader";
import ApplicationPreview from "../components/application-preview/ApplicationPreview";
import RejectDialog from "../components/reject-dialog/RejectDialog";
import Moment from "react-moment";
import Pagination from "../../../../../shared/components/ui/pagination/Pagination";
import Highlighter from "react-highlight-words";
import { TiArrowSortedDown } from "react-icons/ti";
import { GoCheck } from "react-icons/go";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import ConfirmationModal from "../../../../../shared/components/confirmationModal/ConfirmationModal";
import PageHeader from "../../../components/page-header/PageHeader";
import {
  ApplicationWithId,
  MApplicationCountry,
  MApplicationStatus,
  useApplications,
} from "../../../../../contexts/applications-context/ApplicationsContext";

interface IState {
  showRemark: boolean;
  showRemarkPreview: boolean;
  showAcceptConformation: boolean;
  showRejectConformation: boolean;
  showProfileCreationConformation: boolean;
}

const initialState: IState = {
  showRemark: false,
  showRemarkPreview: false,
  showAcceptConformation: false,
  showRejectConformation: false,
  showProfileCreationConformation: false,
};

const Home = () => {
  const [showPreview, setShowPreview] = useState(false);
  const [state, setState] = useState(initialState);

  const appUser = useAppUser();
  const applications = useApplications();

  return (
    <div>
      <PageHeader sidebarOnly={true} title="Applications" />
      <Container
        fluid
        style={{
          paddingTop: "210px",
          paddingLeft: "65px",
          paddingRight: "50px",
          paddingBottom: "10px",
        }}
      >
        <Row>
          <Col
            xs={12}
            md={3}
            xl={3}
            className="d-flex align-items-center ml-md-0 my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <input
                className="app-input input-small search-img"
                style={{ paddingRight: "30px" }}
                placeholder="Team Name"
                value={applications.filters.teamName}
                onChange={(e) => {
                  applications.setFilters({
                    ...applications.filters,
                    teamName: e.target.value,
                  });
                }}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={2}
            xl={2}
            className="d-flex align-items-center my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <select
                className="app-input input-small filter-img"
                value={applications.filters.status}
                onChange={(e) => {
                  applications.setFilters({
                    ...applications.filters,
                    status: e.target.value as any,
                  });
                }}
              >
                <option value={MApplicationStatus.STATUS} disabled hidden>
                  Status
                </option>
                <option value={MApplicationStatus.ALL}>All Status</option>
                <option value={MApplicationStatus.PENDING}>Pending</option>
                <option value={MApplicationStatus.ACCEPTED}> Accepted</option>
                <option value={MApplicationStatus.REJECTED}>Rejected</option>
              </select>
            </div>
          </Col>
          {appUser.userRole.isAdmin && (
            <Col
              xs={12}
              md={2}
              xl={2}
              className="d-flex align-items-center my-1 my-md-0"
              style={{ minWidth: "250px" }}
            >
              <div style={{ flex: "1" }}>
                {" "}
                <select
                  className="app-input input-small filter-img"
                  value={applications.filters.country}
                  onChange={(e) => {
                    applications.setFilters({
                      ...applications.filters,
                      country: e.target.value as any,
                    });
                  }}
                >
                  <option
                    value={MApplicationCountry.SELECT_COUNTRY}
                    disabled
                    hidden
                  >
                    Country
                  </option>
                  <option value={MApplicationCountry.ALL}>All Countries</option>
                  <option value={MApplicationCountry.MALAYSIA}>Malaysia</option>
                  <option value={MApplicationCountry.INDONESIA}>
                    Indonesia
                  </option>
                  <option value={MApplicationCountry.SRI_LANKA}>
                    Sri Lanka
                  </option>
                  <option value={MApplicationCountry.BOSNIA}>
                    Bosnia and Herzegovina
                  </option>
                  <option value={MApplicationCountry.JAMAICA}>Jamaica</option>
                  <option value={MApplicationCountry.INDIA}>India</option>
                </select>
              </div>
            </Col>
          )}
          {applications.years && applications.years.length > 0 ? (
            <Col
              xs={12}
              md={2}
              xl={2}
              className="d-flex align-items-center my-1 my-md-0"
              style={{ minWidth: "250px" }}
            >
              <div style={{ flex: "1" }}>
                {" "}
                <select
                  className="app-input input-small filter-img"
                  value={applications.filters.year}
                  onChange={(e) => {
                    applications.setFilters({
                      ...applications.filters,
                      year: parseInt(e.target.value),
                    });
                  }}
                >
                  <option key={0} value={""} disabled hidden>
                    Year
                  </option>
                  {applications.years
                    .sort((a, b) => (a.appliedYear > b.appliedYear ? -1 : 1))
                    .map((y, i) => (
                      <option key={i + 1} value={y.appliedYear}>
                        {y.appliedYear}
                      </option>
                    ))}
                </select>
              </div>
            </Col>
          ) : (
            <></>
          )}
          <Col
            xs={12}
            md={2}
            xl={2}
            className="d-flex align-items-center my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <button
                className="app-button"
                style={{
                  backgroundColor: "#6c757d",
                  padding: "3px 10px 3px 10px",
                }}
                onClick={() =>
                  applications.setFilters(applications.filters, true)
                }
              >
                Clear filters
              </button>
            </div>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={12}>
            <BarLoader
              height={4}
              width={"100%"}
              color={"#006699"}
              loading={applications.loading}
            />
          </Col>
        </Row>
        <Row className="mt-2 scroll" style={{ overflowX: "auto" }}>
          <Col xs={12} style={{ minHeight: "660px" }}>
            <table className="table-applications">
              <colgroup>
                <col span={1} style={{ width: "40%" }}></col>
                <col span={1} style={{ width: "25%" }}></col>
                <col span={1} style={{ width: "25%" }}></col>
                <col span={1} style={{ width: "10%" }}></col>
              </colgroup>
              <thead>
                <tr>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      applications.setOrders({
                        ...applications.orders,
                        current: "TEAM_NAME",
                        teamName:
                          applications.orders.teamName === "ASCENDING"
                            ? "DESCENDING"
                            : "ASCENDING",
                      })
                    }
                  >
                    Team Name{" "}
                    <TiArrowSortedDown
                      className="order-arrow"
                      style={
                        applications.orders.current === "TEAM_NAME"
                          ? applications.orders.teamName === "ASCENDING"
                            ? { transform: "rotate(0deg)" }
                            : {
                                transform: "rotate(180deg) translateY(2px)",
                              }
                          : { color: "#aaa" }
                      }
                    />
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      applications.setOrders({
                        ...applications.orders,
                        current: "APPLIED_DATE",
                        appliedDate:
                          applications.orders.appliedDate === "ASCENDING"
                            ? "DESCENDING"
                            : "ASCENDING",
                      })
                    }
                  >
                    Applied Date{" "}
                    <TiArrowSortedDown
                      className="order-arrow"
                      style={
                        applications.orders.current === "APPLIED_DATE"
                          ? applications.orders.appliedDate === "ASCENDING"
                            ? { transform: "rotate(0deg)" }
                            : {
                                transform: "rotate(180deg) translateY(2px)",
                              }
                          : { color: "#aaa" }
                      }
                    />
                  </th>
                  <th>Status</th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      applications.setOrders({
                        ...applications.orders,
                        current: "PROFILE",
                        profile:
                          applications.orders.profile === "ASCENDING"
                            ? "DESCENDING"
                            : "ASCENDING",
                      })
                    }
                  >
                    Profiles{" "}
                    <TiArrowSortedDown
                      className="order-arrow"
                      style={
                        applications.orders.current === "PROFILE"
                          ? applications.orders.profile === "ASCENDING"
                            ? { transform: "rotate(0deg)" }
                            : {
                                transform: "rotate(180deg) translateY(2px)",
                              }
                          : { color: "#aaa" }
                      }
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {applications.applications.map(
                  (application: ApplicationWithId, index: number) => (
                    <tr
                      key={index}
                      className="link-label-application"
                      onClick={() => {
                        applications.setSelectedApplicationId(application.id);
                        setTimeout(() => {
                          setShowPreview(true);
                        }, 10);
                      }}
                    >
                      <td>
                        <Highlighter
                          highlightClassName="highlightClass"
                          searchWords={[applications.filters.teamName || ""]}
                          highlightTag={({ children, highlightIndex }: any) => {
                            return (
                              <span className="highlightClass">{children}</span>
                            );
                          }}
                          autoEscape={true}
                          textToHighlight={application.teamName || ""}
                        />
                      </td>
                      <td>
                        <Moment format="MM/DD/YYYY">
                          {application.createdAt?.toDate()}
                        </Moment>
                      </td>
                      <td>
                        <StatusLabel status={application.acceptanceState} />
                      </td>
                      <td style={{ color: "#2ECC71", fontSize: "24px" }}>
                        {application.teamGenerated && <GoCheck />}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </Col>
          <Col xs={12}>
            <Pagination
              pInfo={{
                page: applications.pageNumber,
                totalPages: applications.totalPages,
              }}
              onPageChanged={(page) => {
                applications.setPageNumber(page);
              }}
            />
          </Col>
        </Row>
      </Container>

      {applications.applications.length > 0 &&
        applications.selectedApplication && (
          <ApplicationPreview
            show={showPreview}
            application={applications.selectedApplication}
            applications={applications.applications}
            onHide={() => {
              setShowPreview(false);
            }}
            onAccept={(application) => {
              applications.setSelectedApplicationId(application.id);
              setState({
                ...state,
                showAcceptConformation: true,
              });
            }}
            onReject={(application) => {
              applications.setSelectedApplicationId(application.id);
              setState({
                ...state,
                showRemark: true,
              });
            }}
            loading={applications.loading}
            onCreateProfiles={(application) => {
              applications.setSelectedApplicationId(application.id);
              setState({
                ...state,
                showProfileCreationConformation: true,
              });
            }}
            onShowRemarks={(application) => {
              applications.setSelectedApplicationId(application.id);
              setState({
                ...state,
                showRemarkPreview: true,
              });
            }}
          />
        )}

      {applications.selectedApplication && (
        <RejectDialog
          show={state.showRemark}
          onHide={() => setState({ ...state, showRemark: false })}
          loading={applications.loading}
          application={applications.selectedApplication}
          onReject={(application: ApplicationWithId) => {
            applications.rejectApplication(application, () => {
              setState((ps) => ({ ...state, showRemark: false }));
            });
          }}
        />
      )}
      {applications.selectedApplication && (
        <RejectDialog
          show={state.showRemarkPreview}
          readOnly
          loading={applications.loading}
          onHide={() => setState({ ...state, showRemarkPreview: false })}
          application={applications.selectedApplication}
          onReject={() => {}}
        />
      )}
      <ConfirmationModal
        children={{
          bodyText: "Are you sure you want to accept the application?",
          headerText: "Confirmation",
          confirmButtonText: "Accept",
          cancelButtonText: "Cancel",
          confirmButtonColor: applications.loading ? "grayStatic" : "green",
        }}
        loading={applications.loading}
        show={state.showAcceptConformation}
        onCancel={() =>
          !applications.loading &&
          setState({ ...state, showAcceptConformation: false })
        }
        onConfirm={() =>
          !applications.loading &&
          applications.selectedApplication &&
          applications.acceptApplication(
            applications.selectedApplication,
            () => {
              setState((ps) => ({ ...state, showAcceptConformation: false }));
            }
          )
        }
      />
      <ConfirmationModal
        children={{
          bodyText:
            "When a profile is created, an email will be sent to the team members with login" +
            " details to access the training material. Are you sure you want to create a profile?",
          headerText: "Confirmation",
          confirmButtonText: "Create profile",
          cancelButtonText: "Cancel",
          confirmButtonColor: applications.loading
            ? "grayStatic"
            : "light-blue",
        }}
        loading={applications.loading}
        show={state.showProfileCreationConformation}
        onCancel={() =>
          !applications.loading &&
          setState({ ...state, showProfileCreationConformation: false })
        }
        onConfirm={() =>
          !applications.loading &&
          applications.selectedApplication &&
          applications.createAccounts(applications.selectedApplication, () => {
            setState((ps) => ({
              ...state,
              showProfileCreationConformation: false,
            }));
          })
        }
      />
    </div>
  );
};

export default Home;
